import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {

        fetchSites(ctx, queryParams){
            const data = JSON.stringify(queryParams);
            const sites = new Promise((resolve, reject) => {
                axios
                    .post('/sites/v1/getSites', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
            return sites
        },

        deleteSite(ctx , id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/sites/v1/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateSite(ctx, params){
            return new Promise((resolve, reject) => {
                axios
                    .patch(`/sites/v1/update/${params.id}`, params.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addSite(ctx, params){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/sites/v1/add`, params.data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        getSiteTypes(ctx, params){
            const data = JSON.stringify(params);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/sites/v1/type/getSiteTypes`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addSiteType(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/sites/v1/type/addSiteTypes`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteSiteType(ctx , id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/sites/v1/type/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateSiteType(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/sites/v1/type/update/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        getDestinations(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/sites/v1/destination/getDestinations`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        addDestination(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/sites/v1/destination/addDestination`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateDestination(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/sites/v1/destination/update/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteDestination(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/sites/v1/destination/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }
    }
}